import React, { useEffect, useState } from "react";
import "./Myorder.css";

const Myorder = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [products, setProducts] = useState([]);
  const [userprofileid, setuserprofileid] = useState('');

  useEffect(() => {
    const fetchAllOrderDashboardData = async () => {
      try {
        setLoading(true);
        setError(null);

        let currentUserId = null;
        const userProfile = localStorage.getItem('user_profile');
        if (userProfile) {
          try {
            const parsedData = JSON.parse(userProfile);
            if (parsedData && parsedData.id) {
              currentUserId = parsedData.id;
              setuserprofileid(parsedData.id); // UI/State सिंक के लिए
            }
          } catch (e) {
            console.error("Error parsing user profile from localStorage:", e);
          }
        }

        // अगर यूजर लॉगइन नहीं है तो ऑर्डर्स फेच करने का कोई फायदा नहीं है
        if (!currentUserId) {
          setError("User session profile missing. Please log in.");
          setLoading(false);
          return;
        }

        // 2. ✅ FIXED: Concurrent Network Handshake (Products और User Orders दोनों एक साथ फेच होंगे)
        const [productsRes, ordersRes] = await Promise.all([
          fetch('https://rbuymart.rbhardwaj.com/server/api/products/get_all.php'),
          fetch(`https://rbuymart.rbhardwaj.com/server/api/orders/my_order.php?user_id=${currentUserId}`)
        ]);

        if (!productsRes.ok || !ordersRes.ok) {
          throw new Error("Failure processing downstream architecture matrix.");
        }

        const productsData = await productsRes.json();
        const ordersData = await ordersRes.json();

        // Products स्टेट सेट करें
        setProducts(Array.isArray(productsData) ? productsData : []);

        // Orders डेटा वैलिडेट और सेट करें
        if (ordersData.status === "success") {
          setOrders(ordersData.orders || []);
        } else {
          setError(ordersData.message || "Failed to load execution matrix mapping.");
        }

      } catch (err) {
        console.error("Data pipeline broken:", err);
        setError("Network communication exception tracking failure.");
      } finally {
        setLoading(false);
      }
    };

    fetchAllOrderDashboardData();
  }, []); // ✅ Single point of assembly mounting

  if (loading) {
    return (
      <div className="orders-loading-state">
        <h3>Fetching Your Purchase Ledger...</h3>
      </div>
    );
  }

  if (error) {
    return (
      <div className="orders-error-banner">
        <p>{error}</p>
      </div>
    );
  }

  return (
    <div className="orders-container">
      <h1 className="orders-main-title">My Order</h1>
      {orders.length === 0 ? (
        <div className="empty-orders-view">
          <h3>No order instances found for your session profile matrix.</h3>
        </div>
      ) : (
        <div className="orders-list-wrapper">
          {orders.map((order) => (
            <div key={order.id} className="order-master-card">
              {/* Order Header */}
              <div className="order-card-header">
                <div>
                  <span className="meta-lbl">ORDER PLACED</span>
                  <p className="meta-val">
                    {new Date(order.created_at).toLocaleDateString("en-IN", {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    })}
                  </p>
                </div>
                <div>
                  <span className="meta-lbl">Subtotal + GST</span>
                  <p className="meta-val price-highlight">
                    ₹{Number(order.subtotal || 0).toLocaleString("en-IN")} * 18%
                  </p>
                </div>
                <div className="order-id-block">
                  <span className="meta-lbl">ORDER REFERENCE ID</span>
                  <p className="meta-val">#RBUY-{order.id}</p>
                </div>
                <div className="status-tags-box">
                  <span className={`badge-status method-${order.payment_method ? order.payment_method.toLowerCase() : 'unknown'}`}>
                    {order.payment_method}
                  </span>
                  <span className={`badge-status status-${order.order_status ? order.order_status.toLowerCase() : 'pending'}`}>
                    {order.order_status ? order.order_status.toUpperCase() : 'PENDING'}
                  </span>
                </div>
              </div>

              {/* Product Items List */}
              <div className="order-items-container-body">
                {order.items && order.items.map((item) => (
                  <div key={item.id} className="single-product-item-row">
                    <div className="product-meta-details">
                      {(() => {
                        const matchingProduct = products?.find(p => Number(p.id) === Number(item.product_id));
                        if (matchingProduct && matchingProduct.primary_image) {
                          return (
                            <img
                              src={`https://rbuymart.rbhardwaj.com/server/${matchingProduct.primary_image}`}
                              alt={item.product_name || "Product Image"}
                              className="order-item-thumbnail"
                            />
                          );
                        }
                          return <div className="order-item-thumbnail-placeholder">📦</div>;
                      })()}
                     
                      <div>
                        <h4>{item.product_name}</h4>
                        <p className="product-sub-text">
                          SKU: <strong>{item.sku || "N/A"}</strong> | Qty:{" "}
                          <strong>{item.quantity}</strong>
                        </p>
                        {item.gst_percent && (
                          <span className="gst-applied-tag">
                            Incl. {item.gst_percent}% GST
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Shipping Address Segment */}
              {order.shipping_address && (
                <div className="order-shipping-address-block">
                  <h5>
                    Delivery Destination ({order.shipping_address.address_type || "Home"})
                  </h5>
                  <p>
                    <strong>Name:</strong> {order.shipping_address.name} &nbsp;|&nbsp;
                   <strong>Phone:</strong>  {order.shipping_address.phone} <br />
                    <strong>Address:</strong> {order.shipping_address.address_line1}, {" "}
                    {order.shipping_address.address_line2 ? order.shipping_address.address_line2 + "," : ""} &nbsp;|&nbsp;
                   <strong>City: </strong> {order.shipping_address.city} &nbsp;|&nbsp;
                    <strong>State: </strong> {order.shipping_address.state} -{" "}
                     {order.shipping_address.pincode}
                  </p>
                </div>
              )}

              {/* Order Footer Summary Metrics */}
              <div className="order-card-footer">
                <h2>
                  TOTAL PAY AMOUNT : ₹{Number(order.grand_total || 0).toLocaleString("en-IN")}
                </h2>
                {Number(order.discount) > 0 && (
                  <span className="discount-applied-text">
                    Coupon Discount: -₹{Number(order.discount).toLocaleString("en-IN")}
                  </span>
                )}
                <span>
                  Payment Status:{" "}
                  <strong className={`pay-status-${order.payment_status ? order.payment_status.toLowerCase() : 'unpaid'}`}>
                    {order.payment_status ? order.payment_status.toUpperCase() : 'UNPAID'}
                  </strong>
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Myorder;